// THE QUANTITY ESCAPE ROUTE — DETERMINISTIC UI COPY (cc-7, Sol round-4 design amendment, flagged for ratification).
//
// Previously the classifier was required to weave the escape route INTO every quantity question ("If you know it
// reliably… otherwise…"). Three review rounds proved that in-question enforcement is unverifiable: the model
// paraphrases, the server cannot reliably recognize the shape, and every recognizer invited impostors. So the
// escape route moved HERE: a fixed static hint the client renders under ANY question classified as a quantity ask.
// Deterministic, always present, unmangleable — and copy-contract-safe: it claims nothing about the CV; it
// instructs the answerer.
//
// OVER-DETECTION IS HARMLESS BY DESIGN: the hint is a reassurance line, so a false positive costs nothing. The
// regex mirrors workers/src/lib/questionBurden.ts QUANTITY_QUESTION_RE (kept in sync by the pinned test in
// QualityReadView.test.tsx — the client cannot import worker code).

export const QUANTITY_ASK_RE = /\bhow\s+(?:many|much|often|frequently|long)\b|\bnumber\s+of\b|\bvolume\b|\bcaseload\b|\bper\s+(?:day|week|month|shift)\b/i;

export function isQuantityAsk(question: string): boolean {
  return QUANTITY_ASK_RE.test(question ?? '');
}

/** The fixed escape-route copy. FROZEN WORDING — rendered verbatim wherever a quantity question is shown. */
export const QUANTITY_HINT_COPY =
  'Answer only what you know reliably — an approximate figure, or a description of complexity, autonomy, or continuity instead, is exactly right.';
